import axios from 'axios'
import {URL_SERVER,URL_TRANSPORTE} from "../../api/config";
import {SET_TRANSPORT} from './mutation'

export const actionTransporte = {
    getTransporte({commit}){
        const url = URL_SERVER + URL_TRANSPORTE
        axios.get(url)
            .then(resp =>{
              commit('SET_TRANSPORT', resp.data.items)
            })
            .catch(error =>{
                console.log(error)
            })
    }
}
